import { EventEmitter } from 'events'

export class WebsocketFeed extends EventEmitter {
  connected = false
  constructor(url=WEBSOCKET_TORNADO_URL, server="real", logger=console) {
    super()
    this.url = url
    this.server = server
    this.logger = logger
    this.logger.debug("WebsocketFeed: created")
  }
  connect() {
    this.logger.debug(`WebsocketFeed: connecting to ${this.url}...`)
    this.isConnected = false
    this.client = new WebSocket(this.url)
    this.client.onerror = (error) => {
      this.logger.error("WebsocketFeed: Error", error)
      this.isConnected = false
      this.connect()
      this.emit('error', error)
    }
    this.client.onopen = this.onConnect.bind(this)
    this.client.onclose = this.onDisconnect.bind(this)
    this.client.onmessage = (message) => {
      let data = JSON.parse(message.data)
      this.onMessage(data)
      this.emit('message', data)
    }
  }

  disconnect() {
    this.isConnected = false
    this.client.close()
    delete this.client
  }

  setServer(server) {
    this.server = server
    this.onConnect()
  }

  onDisconnect() {
    if (this.isConnected) {
      this.logger.debug(`WebsocketFeed: disconnected from ${this.url}, reconnecting...`)
      setTimeout(this.connect.bind(this), 1500)
    } else {
      this.logger.debug(`WebsocketFeed: disconnected from ${this.url}`)
    }
    this.isConnected = false
    this.emit('disconnected')
  }

  onConnect() {
    this.logger.debug(`WebsocketFeed: connected to ${this.url}`)
    this.isConnected = true

    //select trading server
    this.client.send(`mode:${this.server}`)

    this.emit('connected')
  }

  onMessage(data) {

  }
}


export class QuotesFeed extends WebsocketFeed {
  quotes = {}
  onConnect() {
    super.onConnect()

    //resubscribe
    let resubQuotes = _.values(this.quotes)

    if(resubQuotes.length) {
      _(this.quotes).values().each(this.client.send.bind(this.client))
      this.logger.debug(`WebsocketFeed: resubscribed to ${resubQuotes.length} quotes`)
    }
  }
  subscribeQuote(quote, context='') {
    this.quotes[quote+context] = quote
    if (this.isConnected) {
      this.client.send(quote)
      this.logger.debug(`WebsocketFeed: subscribed to quote ${quote+context}`)
    }
  }
  unsubscribeQuote(quote, context='') {
    delete this.quotes[quote+context]
    if (this.isConnected) {
      this.client.send(`!${quote}`)
      this.logger.debug(`WebsocketFeed: unsubscribed from quote ${quote+context}`)
    }
  }

  onMessage(data) {
    if(data.symbol)
      this.emit('quote', data.symbol, data)
    else
      super.onMessage(data)
  }
}

export class TradesQuotesFeed extends QuotesFeed {
  onConnect() {
    super.onConnect()
    if(this.tradesTicket) {
      this.client.send(`trades:${this.tradesTicket}`)
      this.logger.debug(`WebsocketFeed: resubscribed to trades by ticket ${this.tradesTicket}`)
    }
  }
  redeemTradesTicket(ticket) {
    this.tradesTicket = ticket
    if(this.isConnected) {
      this.client.send(`trades:${ticket}`)
      this.logger.debug(`WebsocketFeed: subscribed to trades by ticket ${this.tradesTicket}`)
    }
  }

  onMessage(data) {
    if(!data.MsType)
      return super.onMessage(data)

    // Trade removal
    if(data.MsType === 'DeleteTrades')
      this.emit('trade:remove', data)

    // Dunno
    else if(data.MsType === 'TradeRequestResult')
      this.emit('trade:result', data)

    // Trade update
    else if(data.MsType === 'UpDateTrades')
      this.emit('trade:update', data)
  }
}
